import MaterialSkeleton from "../../../../../__snowpack__/pkg/@mui/material/Skeleton.js";
import styled from "styled-components";
export const SkeletonContainer = styled(MaterialSkeleton).withConfig({
  displayName: "merge-units-edit-page-skeletonstyles__SkeletonContainer",
  componentId: "sc-ce2sbu-0"
})(["", ""], {
  borderRadius: "0.5rem"
});
